export class TransportationAlternativesService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.transportationAlternativesResourceUrl = this.apiService.getResourceUrl('menus/TransportationAlternatives');

		this.transportationAlternativesResource = this.$resource(this.transportationAlternativesResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			image: details.image || '',
			description: details.description,
			overview: details.overview,
			slug: details.slug,
			ada: details.ada ? this._getAdaTextObject(details.ada) : {}
		}
	}

	_getAdaTextObject({overview_image_text: overviewImageText}) {
		return {
			overviewImageText
		}
	}

	_getChildrenObject(details) {
		return details.map(value => this._getOverviewDetailsObject(value));
	}

	/**
	 * function to get transportation alternatives content
	 * @return {object} [information related to transportation alternatives]
	 */

	getTransportationAlternativesDetails(details) {
		return {
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			children: this._getChildrenObject(details.data.children)
		};
	}
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternatives/transportation-alternatives.service.js